import { Component, Vue } from 'vue-property-decorator'

@Component({
  template: require('template/_table-results.html'),
  components: {}
})
export default class TableResults extends Vue {

}
